import _extends from "@babel/runtime/helpers/extends";
var _LogoIcon;
import React from 'react';
import styled from 'styled-components';
import TrustpilotLogo from '@tourlane/iconography/Icons/Trustpilot/TrustpilotLogo';
import InfoButton from '../../Info/InfoButton';
import SvgIcon from '../../SvgIcon';
import TrustpilotStars from '../TrustpilotStars/TrustpilotStars';
import { SENSATION_WHITE } from '../../colors';
import { Base } from '../../Typography';
import { isDefined } from '../../helpers/defined';
import { width } from '../../style/width';
import { lineHeight } from '../../style/line-height';
import { fontSize } from '../../style/font-size';
import { padding } from '../../style/padding';
import { marginBottom } from '../../style/margin-bottom';
import { marginTop } from '../../style/margin-top';
import { marginBottomNegative } from '../../style/margin-bottom-negative';
const TRUSTPILOT_BADGE_PADDING = {
  xs: 8,
  md: 16
};
const TRUSTPILOT_BADGE_LOGO_HEIGHT = {
  xs: 20,
  md: 24
};
const TRUSTPILOT_BADGE_LOGO_WIDTH = {
  xs: 80,
  md: 96
};
const TRUSTPILOT_BADGE_STAR_SIZE = {
  xs: 28,
  md: 32
};
const TRUSTPILOT_BADGE_STAR_MARGIN = {
  xs: 2,
  md: 4
};
const Wrapper = styled(InfoButton)`
  display: inline-block;
  width: auto;
  background-color: ${SENSATION_WHITE};
  ${padding(TRUSTPILOT_BADGE_PADDING)}
  ${({
  width: value
}) => isDefined(value) && width(value)}
`;
const LogoIcon = styled(SvgIcon)`
  ${marginBottom(6)}
`;
const BottomText = styled(Base)`
  ${marginTop(4)}
  ${marginBottomNegative({
  xs: 2,
  md: 4
})}
  ${fontSize({
  xs: '10px',
  md: '12px'
})}
  ${lineHeight({
  xs: '14px',
  md: '18px'
})}
`;
const TrustpilotBadge = /*#__PURE__*/React.forwardRef(({
  starsNumber = 5,
  bottomTitle,
  width,
  ...props
}, forwardedRef) => /*#__PURE__*/React.createElement(Wrapper, _extends({
  ref: forwardedRef,
  width: width
}, props), _LogoIcon || (_LogoIcon = /*#__PURE__*/React.createElement(LogoIcon, {
  height: TRUSTPILOT_BADGE_LOGO_HEIGHT,
  width: TRUSTPILOT_BADGE_LOGO_WIDTH,
  color: null
}, /*#__PURE__*/React.createElement(TrustpilotLogo, null))), /*#__PURE__*/React.createElement(TrustpilotStars, {
  number: starsNumber,
  starSize: TRUSTPILOT_BADGE_STAR_SIZE,
  starMargin: TRUSTPILOT_BADGE_STAR_MARGIN
}), bottomTitle && /*#__PURE__*/React.createElement(BottomText, {
  ellipsis: true
}, bottomTitle)));
export default TrustpilotBadge;